import React, { useState, useId } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface FaqItemProps {
  question: string;
  answer: string;
}
export function FaqItem({
  question,
  answer
}: FaqItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();
  return <article className="overflow-hidden rounded-2xl border border-brand-violet/15 bg-white shadow-sm" data-id="element-9" data-mp="1r0lb8xbzrk6y">
      <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setIsOpen(current => !current)} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 hover:bg-brand-mist focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-violet sm:px-6" data-id="element-10" data-mp="1d1bw80ziuw4k">
        <span className="font-display text-lg font-bold leading-snug text-brand-ink sm:text-xl" data-id="element-11" data-mp="1828wmw2b9i3z">
          {question}
        </span>
        <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-brand-violet/10 text-brand-violet" aria-hidden="true" data-id="element-12" data-mp="32frt02kluunp">
          {isOpen ? <MinusIcon className="h-5 w-5" data-id="element-13" data-mp="100joy7pk4xwu" /> : <PlusIcon className="h-5 w-5" data-id="element-14" data-mp="v3b7688bmvw4" />}
        </span>
      </button>
      {isOpen && <div id={panelId} className="px-5 pb-6 text-base leading-relaxed text-brand-ink/75 sm:px-6" data-id="element-15" data-mp="v1gtnezdq622">
          {answer}
        </div>}
    </article>;
}